__turbopack_context__.v({
  "animated": "Logo-module__3vXhqa__animated",
  "backgroundCircle": "Logo-module__3vXhqa__backgroundCircle",
  "bar1": "Logo-module__3vXhqa__bar1",
  "bar2": "Logo-module__3vXhqa__bar2",
  "bar3": "Logo-module__3vXhqa__bar3",
  "dt-logo-pulse-1": "Logo-module__3vXhqa__dt-logo-pulse-1",
  "dt-logo-pulse-2": "Logo-module__3vXhqa__dt-logo-pulse-2",
  "dt-logo-pulse-3": "Logo-module__3vXhqa__dt-logo-pulse-3",
  "image": "Logo-module__3vXhqa__image",
  "logo": "Logo-module__3vXhqa__logo",
  "withBackground": "Logo-module__3vXhqa__withBackground",
});
